// url
// export default 'http://localhost:1337';
export default 'https://react-tech-store-api.herokuapp.com';
